import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import fr from "@/locales/fr/common.json";
import nl from "@/locales/nl/common.json";
import en from "@/locales/en/common.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      nl: { translation: nl },
      en: { translation: en },
    },
    fallbackLng: "fr",
    detection: {
      // `querystring` en premier : un lien ?lng=en (ex. email d'invitation)
      // force la langue à l'arrivée, avant localStorage/navigator.
      order: ["querystring", "localStorage", "navigator"],
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
